import Axios from "axios";

export default {
  get(identification) {
    return Axios.get(
      "/customer/get?identification=" + identification
    );
  }
};